export const employees = {
	tabs: {
		employees: {
			label: "Equipo",
			search: "Buscar",
			filter: "Filtrar por locales",
			addModal: "Agregar colaborador",
			importModal: {
				label: "Importar colaboradores",
				sheetFileName: "Colaboradores",
				buttonText: "Elija una hoja",
				role: "Cargo",
				places: "Locales y Bares",
				permissions: "Permisos",
				columns: {
					name: "Nombre",
					password: "Contraseña",
					username: "Nombre de usuario",
					fichasAmount: "Cantidad de copias en fichas",
					zigTag: "ZigTag",
				},
				selectPlace: "Al menos un local debe ser seleccionado",
				requiredField: "Este campo es obligatorio",
				custom: "Personalizado",
				errorNotification: "Ninguna hoja seleccionada",
				passwordRequirements: `Los empleados que tengan el permiso "Acceso al Dashboard" deben seguir las siguientes reglas para la contraseña: mínimo de 6 caracteres, al menos una letra.`,
			},
			multipleEmployeeModalError: {
				success: "Creado con éxito",
				successMessage: "Los empleados de login {{logins}} fueron creados",
				error: "Falló",
				errorMessage:
					"No fue posible crear los empleados de login {{logins}}. Login ya existente",
			},
			editButton: "Editar colaboradores",
			exportButton: "Exportar colaboradores",
			deleteButton: "Eliminar colaboradores",
			edit: {
				label: "Editar colaborador",
				data: {
					label: "Datos del colaborador",
					name: "Nombre del colaborador",
					login: "Login",
					password: "Contraseña",
					zigCard: "Zig Card",
					employeeNumber: {
						label: "Agregar más de un colaborador",
						tooltip: "Solo para más de un colaborador dentro del mismo cargo",
						start: "De",
						end: "Hasta",
					},
					photo: "Foto",
				},
				extra: {
					label: "Información extra",
					fichasAmount: {
						label: "Cantidad de copias en ficha",
						placeholder: "Cant. de copias",
					},
					type: "Tipo de colaborador",
				},
				places: {
					label: "Locales",
					selectedPlace: "Locales",
					selectedBar: {
						label: "Bares",
						placeholder: "Ninguno",
					},
					mainBar: "Bar principal / punto de venta",
				},
				role: {
					label: "Cargos y permisos",
					employeeRole: {
						label: "Cargo",
						placeholder: "Elija un cargo",
						none: "Ninguno",
						custom: "Personalizado",
					},
					permissions: "Permisos",
				},
				seeProducts: {
					label: "Ver productos de los bares",
					blockedBar: {
						label: "Bloquear bares",
						placeholder: "Ninguno",
					},
				},
			},
			editMultiple: {
				label: "Editar colaborador ({{count}})",
				rename: "Renombrar",
				number: "Numerar a partir de",
				role: "Cambiar cargo",
				places: "Locales",
				bar: "Bares",
				fichasAmount: "Cantidad de copias en ficha",
				info: "Los campos no completados mantendrán sus valores iniciales",
				confirm: "¿Desea modificar los siguientes colaboradores?",
				none: "Ninguno",
				mainBar: "Bar principal",
			},
			employeeDelete: {
				text:
					"¿Realmente desea eliminar a {{name}} ({{role}})? Esta acción no se puede deshacer",
				customized: "Cargo personalizado",
			},
			deleteModal: {
				title: "¿Desea eliminar {{count}} colaborador(es)?",
				content: "¡Atención! Los colaboradores serán eliminados permanentemente.",
			},
			checkAll: "Seleccionar colaboradores ({{counter}})",
			uncheckAll: "Desmarcar todos los colaboradores ({{counter}})",
			columns: {
				name: "Colaborador",
				username: "Login",
				role: "Cargo",
				places: {
					label: "Locales",
					none: "Ningún local seleccionado",
				},
				bar: {
					label: "Bar",
					none: "Ningún bar seleccionado",
				},
				zigtag: "ZigTag",
				custom: "Personalizado",
			},
			createEmployee: {
				fakeBarBlocklistPermission: "Restringir visualización de productos del menú",
				noSelectedPlace: "Seleccione un local para habilitar este permiso",
				onlyOneSelect: "Para habilitar este permiso, seleccione solo un local",
				validation: {
					name: "Ingrese un nombre válido",
					login: "Ingrese un login válido",
					role: "Seleccione un cargo",
					password: "Ingrese una contraseña válida",
					same: "Los valores ingresados son iguales",
					twoValues: "Los dos valores deben ser completados",
					negative: "Los valores no pueden ser negativos",
					initialValueSmaller: "El valor inicial debe ser menor que el final",
					selectedPlaces: "Al menos un local es necesario",
				},
				menuVisualization: {
					title: "Visualización del menú",
					label: "Tipos",
					placeholder: "Seleccione el tipo de visualización",
					type: {
						grid: "Estándar",
						smallGrid: "Foto pequeña",
					},
				},
			},
			importSuccess: "Colaboradores importados con éxito",
			deleteWarning: "¡Ups! Ocurrió un problema, intente nuevamente",
			addEmployeeZigtagError: "Error al agregar colaborador con Zigtag",
		},
		roles: {
			label: "Cargos",
			search: "Busque por cargo",
			create: "Crear cargo",
			edit: "Editar cargo",
			removeRole: "¿Está seguro que desea eliminar el cargo?",
			roleError: "Cargo no encontrado, intente nuevamente",
			isNameInvalid: "Los campos no fueron completados correctamente",
			columns: {
				role: "Cargo",
				employees: "Colaboradores",
				options: "Opciones",
				none: "Ninguno",
			},
			modal: {
				roleName: {
					label: "Nombre del cargo",
					error: "Nombre inválido",
					placeholder: "Ej: Mesero",
				},
				importPermissions: {
					label: "Importar permisos",
					placeholder: "Ej: Cajero",
				},
				permissions: "Permisos",
				placesBar: {
					place: "Locales",
					chooseLocal: "Elija un local",
					bar: "Bares",
					chooseBar: "Elija un bar",
					none: "Ninguno",
					blocked: "Bloquear bares",
					chooseMinimum: "Elija al menos un bar",
				},
			},
		},
	},
};
